import { dateFromString } from '@retail/utils';
import { CalculusConditionDTO } from '../../dtos';
import { ConditionBaseProps, ItemConditionBase } from '../ConditionBase';
import { SupplierBase } from '@retail/suppliers/types';

export interface FreightConditionProps extends ConditionBaseProps<FreightCondition> {
  freightPercentAddon?: number;
  freightFixedAddOn?: number;
  freightFixedAddOnUnit?: string;
}

export class FreightCondition extends ItemConditionBase<FreightCondition> {
  freightPercentAddon?: number;
  freightFixedAddOn?: number;
  freightFixedAddOnUnit?: string;

  constructor({
    freightPercentAddon,
    freightFixedAddOn,
    freightFixedAddOnUnit,
    ...superProps
  }: FreightConditionProps) {
    if (freightPercentAddon == null && freightFixedAddOn == null && freightFixedAddOnUnit == null) {
      throw new Error(`Condition id: ${superProps.id} is missing field for freight value`);
    }
    super(superProps);
    this.freightPercentAddon = freightPercentAddon;
    this.freightFixedAddOn = freightFixedAddOn;
    this.freightFixedAddOnUnit = freightFixedAddOnUnit;
  }

  static fromDto = (dto: CalculusConditionDTO): FreightCondition =>
    new FreightCondition({
      id: dto.id,
      assortmentId: dto.assortmentId,
      assortmentName: dto.assortmentName,
      inDraft: dto.inDraft,
      type: dto.type,
      supplier: dto.supplier ? SupplierBase.fromDto(dto.supplier) : undefined,
      bindingType: dto.bindingType,
      bindingTarget: dto.bindingTarget,
      bindingTargetName: dto.bindingTargetName,
      bindingTargetId: dto.bindingTargetId,
      bindingTargetItem: dto.bindingTargetItem,
      validFrom: new Date(dto.validFrom),
      validTo: dateFromString(dto.validTo),
      freightPercentAddon: dto.freightPercentAddon,
      freightFixedAddOn: dto.freightFixedAddOn,
      freightFixedAddOnUnit: dto.freightFixedAddOnUnit,
    });
}
